import { useState, useEffect } from "react";

export default function CountdownTimer({ targetDate }) {
  const [timeLeft, setTimeLeft] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });

  useEffect(() => {
    function calculateTimeLeft() {
      const difference = new Date(targetDate) - new Date();
      if (difference <= 0) {
        return { days: 0, hours: 0, minutes: 0, seconds: 0 };
      }
      return {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    }

    setTimeLeft(calculateTimeLeft());
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);
    return () => clearInterval(timer);
  }, [targetDate]);

  const units = [
    { label: "DIAS", value: timeLeft.days },
    { label: "HORAS", value: timeLeft.hours },
    { label: "MIN", value: timeLeft.minutes },
    { label: "SEG", value: timeLeft.seconds },
  ];

  return (
    <div data-testid="countdown-timer" className="flex items-center justify-center gap-3 md:gap-6">
      {units.map((unit, i) => (
        <div key={unit.label} className="flex items-center gap-3 md:gap-6">
          <div className="flex flex-col items-center">
            <div className="countdown-digit text-3xl md:text-5xl lg:text-6xl font-light text-white tabular-nums min-w-[60px] md:min-w-[80px]">
              {String(unit.value).padStart(2, "0")}
            </div>
            <span className="font-['JetBrains_Mono'] text-[10px] md:text-xs tracking-[0.15em] text-white/30 mt-2">
              {unit.label}
            </span>
          </div>
          {i < units.length - 1 && (
            <span className="text-2xl md:text-4xl text-[#00FF00]/50 font-light self-start mt-1">:</span>
          )}
        </div>
      ))}
    </div>
  );
}
